var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKlaviyoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1555 121.306L121.088 83.2518C123.612 81.8122 126.704 81.8122 129.228 83.2518L187.16 121.306C189.432 122.433 190.442 125.124 189.306 127.44C188.864 128.379 188.107 129.13 187.16 129.568L179.398 134.638C160.403 104.908 120.772 96.0827 90.7963 114.86C82.7817 119.929 75.9662 126.627 70.8546 134.638L63.0293 129.568C60.7575 128.379 59.874 125.625 61.0099 123.372C61.5148 122.496 62.272 121.745 63.1555 121.306ZM125.063 120.868C108.466 120.931 93.005 129.381 84.1701 143.338L97.4856 152.101C106.636 137.017 126.389 132.197 141.534 141.273C146.015 143.964 149.738 147.657 152.452 152.101L165.767 143.338C157.058 129.318 141.66 120.806 125.063 120.868ZM125.063 152.664C119.194 152.727 113.83 155.856 110.927 160.926L119.889 166.747C121.34 167.999 123.17 168.624 125.063 168.624C126.957 168.624 128.85 167.936 130.238 166.747L139.199 160.926C136.359 155.794 130.932 152.664 125.063 152.664Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 125.116,
    y1: 168.602,
    x2: 125.116,
    y2: 82.1825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3314,
    stopColor: "#92C84E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4859,
    stopColor: "#71BF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7506,
    stopColor: "#15B158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "#23AC69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23AC69"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaviyoLogo);
export default __webpack_public_path__ + "static/media/KlaviyoLogo.56dae8da4b4231952ded0bc3adcd30bd.svg";
export { ForwardRef as ReactComponent };